// 卡牌配置定义
export interface CardConfig {
    id: string; // '001', '002' 等
    type: string; // 'tarot', 'iching' 等，用于路由
    name: string; // 显示名称
    assetsPath: string; // 图片文件夹路径 relative to src/assets/picture
    hasReversed: boolean; // 是否有逆位
    aiRole: string; // AI 角色名
    defaultQuestions: string[]; // 默认问题
    backImage?: string; // 背面图路径 (optional)
}

// 默认配置列表
export const CARD_CONFIGS: Record<string, CardConfig> = {
    '001': {
        id: '001',
        type: 'tarot',
        name: 'Tarot',
        assetsPath: 'tarotCards',
        hasReversed: true,
        aiRole: '塔罗牌占卜师',
        defaultQuestions: [
            "What does this card reveal about my current situation?",
            "How can I overcome the challenges ahead?",
            "What opportunities should I be aware of?",
            "What is blocking my progress right now?",
            "How can I improve my relationships?",
            "What should I focus on for personal growth?",
        ]
    },
    '002': {
        id: '002',
        type: 'iching',
        name: 'I Ching',
        assetsPath: 'IChing',
        hasReversed: false,
        aiRole: '易经占卜师',
        defaultQuestions: [
            "What does this hexagram reveal about my current situation?",
            "How can I overcome the challenges ahead?",
            "What opportunities should I be aware of?",
            "What lesson is the universe teaching me?",
            "How can I find more balance in my life?",
            "What hidden potential do I have?",
        ]
    }
    // 未来添加更多：
    // '003': { ... }
};

// 辅助函数：通过 ID 或 Type 获取配置
export const getCardConfig = (identifier: string): CardConfig | undefined => {
    // 尝试直接通过 key 获取
    if (CARD_CONFIGS[identifier]) return CARD_CONFIGS[identifier];

    // 尝试通过 type 查找
    return Object.values(CARD_CONFIGS).find(c => c.type === identifier);
};
